import { useAppSelector } from "../../../app/hooks";
import { isAdIIPurpose } from "../utils/remitterKycFlow";

/**
 * Digio A2 e-sign is AD-II only.
 * Enabled when purpose adCategory is AD-II and the transaction vendor
 * has adIINewKycRequired from ad-ii-config. AD-I always uses legacy A2 e-sign.
 */
export const useDigioEsignEnabled = () => {
  const adCategory = useAppSelector(
    (state) => state.remittance.calculator.amountCalculation?.purposeDropdown?.adCategory
  );
  const adIINewKycRequired = useAppSelector(
    (state) =>
      state.remittance.remitter.getTransLoggedInVendorConfig?.data?.transactionVendor
        ?.adIINewKycRequired
  );

  if (!isAdIIPurpose(adCategory)) {
    return false;
  }

  return Boolean(adIINewKycRequired);
};
